import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

export const hanaAuthTypes = {
    Basic: 'Basic',
    Windows: 'Windows'
};
@Metamodel.model({
    name: adfModelTypeMap.sapHana.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapHana_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SapHana_DisplayText)
    ]
})

export class SapHanaLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        association: 'SERVER',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        association: 'PASSWORD',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    // distinguish old mashup resource from new odbc resource, if we open the feature flag, all existing resources are OldMashupResource
    // we will set this value in toModel based on 'server' property, undefined means newly create resource.
    public isOldMashupResource: boolean;
    // user should be able to create mashup resource by using old IR even if we turn on the feature flag,
    // isMashupResource is used to mark these resources, and we set this value in BOTH toModel and toResource
    public isMashupResource: boolean;

    public enableAKV?: boolean = false;

    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
